export default __webpack_public_path__ + "static/media/intro.35cfedd2.gif";